<script>
    import {api, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import LoadingCert from '../components/LoadingCert.svelte';
    import ImageCert from '../components/ImageCert.svelte';
    
    const user = store('credentials', 'appUserAuth');
    const fetchAllCerts = (async () => {
        let result = await api('appUserCert', {login: $user.email});
        return result.data ? result.data : [];
    })();
    
    const handlerSaveCert = (id) => {
        let img = document.querySelector('#cert-' + id),
            arr = img.src.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
    
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
    
        // сохраняем файл
        let link = document.createElement('a');
            link.download = img.dataset.name + '.png';
            link.href = URL.createObjectURL(new Blob([u8arr], {type: mime}));
            link.click();
        URL.revokeObjectURL(link.href);
    }
</script>

<TopMenu title="Сертификаты участника">
    <TopMenu_BackBtn slot="back" href="/dashboard" />
</TopMenu>

<div id="appCapsule">
    {#await fetchAllCerts}
        <LoadingCert />
    {:then data}
        <div class="section mb-4">
            {#if data.length}
                <div class="row">
                    {#each data as {evantName, evantDate, opis, name, shablon2, nomer}, i}
                        <div class="col-12 col-md-10 col-lg-6 mx-md-auto mb-2">
                            <div class="card">
                                <ImageCert
                                    id="cert-{i}"
                                    data-event-name="{evantName}"
                                    data-event-date="{evantDate}"
                                    data-opis="{opis}"
                                    data-name="{name}"
                                    data-nomer="{nomer}"
                                    class="canvas card-img-top d-block mx-auto"
                                    crossorigin="anonymous"
                                    src="https://225304.selcdn.ru/miin/{shablon2}"
                                    alt="{name}"
                                    title="{name}" />
    
                                <div class="card-footer text-center">
                                    <button type="button" class="btn btn-primary btn-block" on:click={() => handlerSaveCert(i)}>Сохранить</button>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            {:else}
                <div class="error-page">
                    <h1 class="title">Сертификатов пока нет</h1>
                    <div class="text mb-5">
                        Полученные вами сертификаты будут отображаться на этой странице.
                    </div>
                </div>
            {/if}
        </div>
    {/await}
</div>
